export const HeaderPrefix = 'mx-insights-';

export const insightsHeader = (key: string): string => `${HeaderPrefix}${key}`;
